export default "__VITE_ASSET__ebdf402c__"